import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-date-label',
  template: `
    <div class="la-date-label">
      <la-text [color]="'seafoam-1'" [kind]="size === 'md'? 'title-3': 'title-4'" class="la-date-label__day">{{dayNumber}}</la-text>
      <la-text [color]="'midnight-3'" [kind]="size === 'md'? 'title-3': 'title-4'" class="la-date-label__month">{{monthName}}</la-text>
    </div>
  `,
  styles: [`
    .la-date-label{width:44px;height:44px;background:#fff;border-radius:50%;display:inline-block}.la-date-label__day,.la-date-label__month{display:block;text-align:center;position:relative}.la-date-label__day{top:2px}.la-date-label__month{top:-8px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaDateLabelComponent {
  private _monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Arp',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  private _date: Date;

  get date(): Date {
    return this._date;
  }

  @Input()
  set date(date: Date) {
    this._date = date;
    this.dayNumber = this._date.getDate();
    this.monthName = this._monthNames[this._date.getMonth()];
  }

  private _dayNumber: number;

  get dayNumber(): number {
    return this._dayNumber;
  }

  set dayNumber(number: number) {
    this._dayNumber = number;
  }

  private _size = 'md'

  get size(): string {
    return this._size;
  }

  @Input()
  set size(size: string) {
    this._size = size;
  }

  private _monthName: string;

  get monthName(): string {
    return this._monthName;
  }

  set monthName(name: string) {
    this._monthName = name;
  }
}
